export default "__VITE_ASSET__fv3s_3$w__"